/**
 * Convert an ISO formatted date string to dd-mm-yyyy format (WHATEVER the user locale)
 * All dates in cockpit are displayed using this format.
 *
 * @param isoDate date in ISO format
 * @return 'dd-mm-yyyy' string
 */
export function formatDate(isoDate: string) {
  const date = new Date(isoDate);
  const dd = date.getDate().toString().padStart(2, '0');
  const mm = (date.getMonth() + 1).toString().padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}-${mm}-${yyyy}`;
}

export function formatDateTime(isoDate: string) {
  const date = new Date(isoDate);
  const dd = date.getDate().toString().padStart(2, '0');
  const mm = (date.getMonth() + 1).toString().padStart(2, '0');
  const yyyy = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0')
  const mins = date.getMinutes().toString().padStart(2, '0')
  const secs = date.getSeconds().toString().padStart(2, '0')
  return `${yyyy}-${mm}-${dd}  ${hours}:${mins}:${secs}`;
}

/**
 * Date comparison for aggrid date flters
 * May be replaced by datefns call by taking care of timezones
 *
 * @param referenceDate the date we want to compare ou tested date to
 * @param testedDateStr  the tested date
 * @returns 0 if dates are equal, -1 if tested date is before reference date, 1 otherwise
 */
export function compareDates(referenceDate: Date, testedDateStr: string | null) {
  if (testedDateStr == null) return -1;
  const testedDate = new Date(testedDateStr);

  const refYear = referenceDate.getFullYear();
  const testedYear = testedDate.getFullYear();
  if (testedYear < refYear) return -1;
  if (testedYear > refYear) return 1;

  const refMonth = referenceDate.getMonth();
  const testedMonth = testedDate.getMonth();
  if (testedMonth < refMonth) return -1;
  if (testedMonth > refMonth) return 1;

  const refDay = referenceDate.getDate();
  const testedDay = testedDate.getDate();
  if (testedDay < refDay) return -1;
  if (testedDay > refDay) return 1;

  return 0;
}

export const formatDateRefresh = (dateInput: Date) => {
  const date = new Date(dateInput) || new Date();
  const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
  return formattedDate;
};

export const formatOnlyDate = (dateInput: Date) => {
  const date = new Date(dateInput) || new Date();
  const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()}`;
  return formattedDate;
};
